export const PRODUCTS_PER_PAGE = 36

export const HEADER_MAX_WIDTH = 650
